export interface DetallesCupsMulticauAPI {
  codiClient: string;
  comunidadId: string;
  comunidadNombre: string;
  esClienteECE?: string;
  esClienteElecsum?: string;
  esComunidad?: string;
  esFotovoltaica?: string;
  esTarifaIndexada?: string;
  modem?: string;
  estadoCliente?: 'activa' | 'baja' | null;
  clienteEstaDeBaja?: string;
}

export default class DetallesCupsMulticau {
  codiClient: string;

  comunidadId: string;

  comunidadNombre: string;

  esClienteECE: string;

  esClienteElecsum: string;

  esComunidad: string;

  esFotovoltaica: string;

  esTarifaIndexada: string;

  modem: string;

  estadoCliente: 'activa' | 'baja' | null;

  clienteEstaDeBaja: string;

  constructor(input?: DetallesCupsMulticauAPI) {
    this.codiClient = input?.codiClient || '';
    this.comunidadId = input?.comunidadId || '';
    this.comunidadNombre = input?.comunidadNombre || '';
    this.esClienteECE = input?.esClienteECE || '';
    this.esClienteElecsum = input?.esClienteElecsum || '';
    this.esComunidad = input?.esComunidad || '';
    this.esFotovoltaica = input?.esFotovoltaica || '';
    this.esTarifaIndexada = input?.esTarifaIndexada || '';
    this.modem = input?.modem || '';
    this.estadoCliente = input?.estadoCliente ?? null;
    this.clienteEstaDeBaja = input?.clienteEstaDeBaja || '';
  }
}

// Un detalle multicau debe mostrarse (chip) y contar para la selección por defecto siempre que
// represente una pertenencia REAL a la comunidad, esté `activa` o de `baja` (los de baja se
// siguen mostrando con su etiqueta). El backend ha tenido dos formatos: el antiguo solo trae
// `estadoCliente` ('activa' | 'baja' | null) y el nuevo añade `clienteEstaDeBaja` ('si' | 'no'),
// dejando a veces `estadoCliente` a null. El filtro antiguo `estadoCliente !== null` descartaba
// clientes válidos del formato nuevo (estado null) y dejaba `selectedMulticau` a null, bloqueando
// el dashboard. Conservamos cualquier detalle con bandera nueva o con estado conocido.
export const isVisibleMulticauDetalle = (d: {
  estadoCliente?: 'activa' | 'baja' | null;
  clienteEstaDeBaja?: string;
}): boolean => !!d.clienteEstaDeBaja || d.estadoCliente != null;
